import AWS from "aws-sdk"
import CryptoJS from "crypto-js";

export function createS3(s3Bucket, req) {
    const keys = process.env.S3_KEY && process.env.S3_SECRET
        ? {S3_KEY: process.env.S3_KEY, S3_SECRET: process.env.S3_SECRET}
        : JSON.parse(CryptoJS.AES.decrypt(req.header('x-dosvit-keys'), process.env.APP_KEY).toString(CryptoJS.enc.Utf8));
    const endpoint = process.env.S3_HOST.startsWith('localhost')
        ? process.env.S3_HOST
        : process.env.S3_PROTOCOL + s3Bucket + '.' + process.env.S3_HOST;
    // debug messages
    // console.log('Creating S3 connection for endpoint ' + endpoint);
    // console.log('Using keys:');
    // console.log(keys);
    return new AWS.S3({
        endpoint: new AWS.Endpoint(endpoint),
        s3BucketEndpoint: true,
        credentials: new AWS.Credentials({
            accessKeyId: keys.S3_KEY,
            secretAccessKey: keys.S3_SECRET
        })
    });
}
